import axios from "axios";

export default axios.create({
  //baseURL: "https://localhost:44318/api"
  //baseURL: "/api"
  baseURL: "https://api.labitalee.com/api"
});
